import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { NewsService } from 'services';
import { SectionWithArrows } from 'components/organisms';
import { HeroImageBackground } from 'components/organisms';
import { useTranslation } from 'react-i18next';
import NewsDocCard from './components/NewsDocCard';

const newsService = new NewsService();

const useStyles = makeStyles((theme) => ({
  root: {
    '& .section': {
      paddingTop: theme.spacing(4),
    },
  },
  heroTitle: {
    fontSize: '3rem',

    [theme.breakpoints.down('md')]: {
      fontSize: '2.5rem',
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '2rem',
    },

    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  image: {
    width: '33%',
    marginRight: theme.spacing(2),
  },
  titleContainer: {},
  title: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
  date: {
    fontSize: '1.1rem',
    fontWeight: 300,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
    textAlign: 'right',
  },
  content: {
    paddingTop: theme.spacing(0),
  },
  description: {
    marginTop: 20,
    textAlign: 'justify',
    textJustify: 'inter-word',
  },
  documentContainer: {
    marginTop: theme.spacing(4),
  },
}));

const LatestNewDetails = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [news, setNews] = useState({});

  const { newsId } = useParams();

  useEffect(() => {
    (async () => {
      const { data } = await newsService.newsDetails(newsId);

      if (!data) history.push('/');
      else setNews(data);
    })();
  }, [history, newsId]);

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <HeroImageBackground
        title={news.title}
        classes={{
          title: classes.heroTitle,
        }}
        // backgroundImg={news.cover?.}
        backgroundImg='/assets/images/latest-news-cover.jpg'
        backgroundIcon='LatestNews/LatestNews'
        height={210}
        mobileHeight={200}
      />
      <SectionWithArrows className={classes.content}>
        <p>
          <img className={classes.image} src={news.cover?.src} alt={news.title} align='left' />
          {/* <br clear='right' /> */}
          <Typography variant='subtitle1' className={classes.date}>
            {news.date}
          </Typography>
          <Typography
            className={classes.description}
            variant='body1'
            dangerouslySetInnerHTML={{
              __html: news.description,
            }}
          ></Typography>
        </p>
        <Grid container spacing={2} className={classes.documentContainer}>
          {news.docs?.map((doc) => (
            <Grid item md={3} sm={6} xs={12}>
              <NewsDocCard title={doc.title} url={doc.url} urlText={t('LATEST_NEWS.DOWNLOAD_DOC')} />
            </Grid>
          ))}
        </Grid>
      </SectionWithArrows>
    </div>
  );
};

LatestNewDetails.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default LatestNewDetails;
